//'68.472-4'
import { Pipe, PipeTransform } from '@angular/core';

@Pipe(
    {
        name:'pacFormat',
        standalone: false
    }
)
export class PacFormat implements PipeTransform{
    transform( value: string | number) : string|number{
        var formatTemp = (value +'').split('');
                return (formatTemp.slice(0,2)+'.'+formatTemp.slice(2,5)+'-'+formatTemp.slice(5)).replace(/,/g,'');//180211
    }

}